module.exports = __webpack_public_path__ + "dcfac78a746ffc769775c369daa15115.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-23.png
// module id = 1570
// module chunks = 0